<template>
  <div style="display: flex;
    flex-wrap: wrap;
    justify-content: center;">
    <!-- <div> -->

    <img src="../assets/jfs/banner .png" class="fruit_img" />
    <!-- </div> -->
    <img src="../assets/jfs/znjf.png" style="margin-top: 40px;" />
    <img src="../assets/jfs/jhyq11.png" />
    <img src="../assets/jfs/yyjz.png" />
    <div class="zu">
      <img class="zuone" src="../assets/jfs/z1.png" style="margin-right: 18px;" />
      <img class="zuone" src="../assets/jfs/z2.png" style="margin-left: 18px;" />
      <img class="zuone" src="../assets/jfs/z3.png" style="margin-right: 18px;" />
      <img class="zuone" src="../assets/jfs/z4.png" style="margin-left: 18px;" />
    </div>

    <!-- <div class="zu" style="
    background: #ffffff;">
      <img class="zuw" src="../assets/jfs/jssllx.png" />
      <img class=" zuw" src="../assets/jfs/ccdms.png" />
      <img class="zuw" src="../assets/jfs/fxxx.png" />
      <img class="zuw" src="../assets/jfs/qwbz.png" />
    </div> -->
    <img style="margin-top: 60px; width: 1902px; height: 1050px;" src="../assets/jfs/z5.png" />
    <div class="zxls">

      <img style="width: 1920px;height: 536px; position: relative;" src="../assets/jfs/ghs.jpg" />
      <el-button class="lis" style="top: -218px;left: 908px;" @click="() => {
        this.$router.push({ name: 'Contactus' });
      }">立即咨询</el-button>
      <!-- <el-button class="lis" style="top: -218px;left: 1108px;" @click="() => {
        this.$router.push({ name: 'Applica' });
      }">免费试用</el-button> -->
    </div>
    <!-- <div style="font-size: 25px;font-weight: bold;margin-top: 20px">拥有自己的外卖平台</div> -->
    <!-- <div style="font-size: 20px;font-weight: normal;margin-top: 20px;margin-bottom: 15px">为商家快速搭建专业的外卖平台 圈住门店半径5公里内的微信用户 -->
    <!-- </div> -->
    <!-- <div class="delivery">
      <div class="deliver_img_parent">
        <img class="fruit_product_img" src="../assets/other/水果外卖.png" />
      </div>
      <div class="deliver_parent">
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[0].img" />
          </div>
          <div class="delivery_border_title">{{ delivery[0].title }}</div>
          <div class="delivery_border_content">{{ delivery[0].contents[0] }}</div>
        </div>
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[1].img" />
          </div>
          <div class="delivery_border_title">{{ delivery[1].title }}</div>
          <div class="delivery_border_content">{{ delivery[1].contents[0] }}</div>
        </div>
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[2].img" />
          </div>
          <div class="delivery_border_title">{{ delivery[2].title }}</div>
          <div class="delivery_border_content">{{ delivery[2].contents[0] }}</div>
        </div>
      </div>
    </div> -->
    <!--<div>水果</div>-->

  </div>
</template>
<script>
export default {
  name: 'Fruit',
  data() {
    return {
      delivery: [
        {
          img: require('../assets/other/定位图标.png'),
          title: "自定义配送范围",
          contents: ["商家后台自定义配送范围"]
        }, {
          img: require('../assets/other/骑车送.png'),
          title: "支持自定义配送",
          contents: ["商家自己优选配送路径"]
        }, {
          img: require('../assets/other/券.png'),
          title: "线上优惠券福利",
          contents: ["各种优惠福利提升用户消费"]
        }
      ]
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.lis {
  position: relative;
  width: 230px;
  height: 70px;
  font-size: 22px;
}

.lis:hover {
  background-color: #1E9FFF;
  color: #fff;
}

.zxls {
  margin-top: 60px;
  width: 1920px;
  background: #fafafc;
}

.delivery_border {
  height: auto;
  margin: 20px;
  width: 55%;
  /*border-radius: 6px;*/
  /*border: 1px solid #EBEEF5;*/
}

.zu {
  width: 1920px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
}

.zuone {
  width: 682px;
  height: 285px;
  margin-top: 32px;
}

.zuw {
  width: 682px;
  height: 285px;
  margin-right: 18px;
  margin-top: 18px;
}

.delivery_border_img {
  margin-top: 20px;
  width: 70px;
  height: 70px;
}

.delivery_border_title {
  margin-top: 10px;
  font-size: 1.25em;
  font-weight: normal;
}

.delivery_border_content {
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: normal;
}

.fruit_img {
  margin-top: 64px;
  width: 1920px;
  height: 674px;
}

.fruit_product_img {
  height: 500px;
  width: 260px;
}

.deliver_parent {
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.deliver_img_parent {
  width: 30%;
  height: auto;
}

.delivery {
  display: flex;
  height: 550px;
  width: 1281px;
  margin: auto;
  justify-content: center;
  align-items: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .fruit_img {
    height: 250px;
    width: 100%;
  }

  .fruit_product_img {
    height: 400px;
    width: 240px;
  }

  .delivery_border_img {
    margin-top: 20px;
    width: 70px;
    height: 70px;
  }

  .deliver_img_parent {
    width: 100%;
    float: left;
    height: 400px;
  }

  .deliver_parent {
    float: left;
    margin-top: 5px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .delivery_border {
    height: auto;
    margin: 10px 0 auto;
    width: 100%;
    float: right;
    border-radius: 6px;
    border: 1px solid #EBEEF5;
  }

  .delivery {
    display: flex;
    width: 1281px;
    height: auto;
    margin: auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .delivery_border_title {
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: normal;
  }

  .delivery_border_content {
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: normal;
    margin-bottom: 10px;
  }
}
</style>